<template>
  <div class="login-page">
    <div class="left-area">
      <img src="../../assets/images/icon.png">
      <span class="el-header__title">货车联名卡数据管理平台</span>
    </div>
    <div class="nav">
      <!-- <langselect class="lang" /> -->
      <!-- <el-tooltip class="svg-github" effect="dark" content="Fork Me" placement="bottom"> -->
      <!-- <a href="https://github.com/Sakuyakun/vue-eden"><icon name="github" :scale="2.5"></icon></a> -->
      <!-- </el-tooltip> -->
    </div>

    <div class="login-wrap">
      <el-col :class="translateLeft" :span="10" class="login-box">
        <div v-if="notforget">
          <div class="logo">
            <!-- <icon name="tree" :scale="8"></icon> -->
            <div class="title">
              <a>
                <!-- <span>{{$t('login.edenPart1')}}</span><span class="subtitle">{{$t('login.edenPart2')}}</span> -->
                <span>账号登录</span>
              </a>
            </div>
          </div>

          <div class="login-form">
            <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
              <el-form-item prop="username">
                <el-input :placeholder="$t('login.userplaceholder')" v-model="ruleForm.username">
                  <template slot="prepend">
                    <icon name="phone" :scale="2"></icon>
                  </template>
                </el-input>
              </el-form-item>
              <el-form-item prop="password">
                <el-col :span="15">
                  <el-input
                    :placeholder="$t('login.pwdplaceholder')"
                    type="password"
                    v-model="ruleForm.password"
                    @keyup.enter.native="handleLogin('ruleForm')"
                  >
                    <template slot="prepend">
                      <icon name="message" :scale="2"></icon>
                    </template>
                  </el-input>
                </el-col>
                <el-col :offset="1" :span="4">
                  <el-button v-show="show" @click="getIdentifyingCode">
                    <span>获取验证码</span>
                  </el-button>
                  <el-button v-show="!show">
                    <span class="count">{{count}} s</span>
                    <!-- 获取验证码{{count}} -->
                  </el-button>
                </el-col>
              </el-form-item>
              <el-form-item class="btn">
                <el-button
                  :loading="loading"
                  type="primary"
                  @click="handleLogin('ruleForm')"
                >{{$t('login.btn')}}</el-button>
              </el-form-item>
            </el-form>
          </div>

          <div class="login-footer">
            <el-col :span="12">
              <el-checkbox v-model="remember" name="type">{{$t('login.remember')}}</el-checkbox>
            </el-col>
            <!-- <el-col class="forgetpwd" :span="12">
              <span @click="wrapSwitch(false)">{{$t('login.forgetpwd')}}</span>
            </el-col>-->
          </div>
        </div>

        <div v-else>
          <div class="title forgetwrap-title">
            <a>
              <span>VUE</span>
              <span class="subtitle">EDEN</span>
            </a>
          </div>
          <div class="forget-form">
            <el-form :model="forgetForm" ref="forgetRuleForm">
              <el-form-item>
                <el-input :placeholder="$t('login.forget_email')" v-model="forgetForm.email"></el-input>
              </el-form-item>
              <el-form-item>
                <el-input :placeholder="$t('login.forget_code')" v-model="forgetForm.code"></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  :placeholder="$t('login.forget_passwrd')"
                  type="password"
                  v-model="forgetForm.newPassword"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-input
                  :placeholder="$t('login.confirm_passwrd')"
                  type="password"
                  v-model="forgetForm.confirmPassword"
                ></el-input>
              </el-form-item>
              <el-form-item class="btn">
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-button @click="wrapSwitch(true)" type="primary">{{$t('login.forget_back')}}</el-button>
                  </el-col>
                  <el-col :span="12">
                    <el-button @click="forgetHandle" type="primary">{{$t('login.forget_btn')}}</el-button>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-col>

      <!-- <el-col :class="translateRight" :span="14">
        <div class="wallpaper"></div>
      </el-col>-->
    </div>
  </div>
</template>

<script>
import langselect from '@/components/langselect'
import storage from '@/utils/storage'
import { getIdentifyingCodes,getUserInfo } from '@/api/login'
import { IEVersion } from '@/utils/tools'
import Cookies from 'js-cookie'
// const useRegexp = {
//   exist: /\S+/
// }

export default {
  name: 'login',
  components: {
    langselect
  },
  created() {
    this.judgeClient()
  },
  mounted() {},
  data() {
    return {
      lang: this.$store.state.app.language,
      ruleForm: {
        username: storage.get('loginUser'),
        password: ''
      },
      rules: {
        username: [
          {
            pattern: /^((13[0-9])|(17[0-9])|(14[5|7])|(15([0-9]))|(16[0-9])|(18[0-9])|(19[0-9]))\d{8}$/,
            message: '请输入正确的手机号码',
            trigger: 'blur',
            required: true
          }
        ],
        password: [
          { message: '请输入正确的验证码', trigger: 'blur', required: true }
        ]
      },
      show: true,
      timer: null,
      count: '',
      remember: true,
      loading: false,
      switchLeft: false,
      switchRight: false,
      notforget: true,
      forgetForm: {
        email: '',
        newPassword: '',
        confirmPassword: ''
      }
    }
  },
  computed: {
    translateLeft() {
      return {
        'translate-left': true,
        'login-col': true,
        'switch-left': this.switchLeft
      }
    },
    translateRight() {
      return {
        'translate-right': true,
        'login-col': true,
        'switch-right': this.switchLeft
      }
    }
  },
  methods: {
    judgeClient() {
      let client = IEVersion()
      if (client != -1 && client <= 8) {
        this.$notify({
          title: '登陆提示',
          message: '请使用谷歌浏览器或者升级您的浏览器到最新版本',
          position: 'top-left',
          duration: 0
        })
      }
    },
    getIdentifyingCode() {
      return new Promise(async (resolve, reject) => {
        try {
          const identifyingCode = await getIdentifyingCodes(
            this.ruleForm.username
          )
          console.log(identifyingCode)
          if (identifyingCode.code === 200){
            this.getCode()
            resolve()
          }
        } catch (err) {
          reject(err)
        }
      })
    },
    getCode() {
      const TIME_COUNT = 60
      if (!this.timer) {
        this.count = TIME_COUNT
        this.show = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            this.show = true
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    },
    handleLogin(formName) {
      this.loading = true
      this.$refs[formName].validate(async valid => {
        if (valid) {
          try {
            let { username, password } = this.ruleForm
            this.remember
              ? storage.set('loginUser', username)
              : storage.remove('loginUser', username)
            storage.set('password', password)
            const response = await this.$store.dispatch('loginbyUser', {
              username: username,
              password: password
            }) //返回登陆成功后的参数
            this.loading = false
            if (response.data) {
              const response = await getUserInfo(Cookies.get('user'))
              Cookies.set('userType', response.data.userType);
              if(response.data.userType==2){
                storage.set('areaList',response.data.areaList);
              }
              let path = response.data.menuList[0].libList[0].pageUrl||'/';
              this.$notify.closeAll()
              this.$router.push({ path: path })
            } else {
              this.$message({
                message: response.message,
                type: 'error',
                duration: 10000,
                showClose: true
              })
            }
          } catch (error) {
            throw new Error(error)
          }
        } else {
          this.loading = false
          this.$message.error(this.$t('login.validfaild'))
        }
      })
    },
    forgetHandle() {
      this.$message.success(this.$t('login.pwdChanged'))
      this.wrapSwitch(true)
    }
  }
}
</script>

<style lang="stylus">
.forget-form, .login-form {
  .el-form-item__content {
    line-height: 40px;
  }

  .el-input__inner {
    padding-top: 2px;
    height: 40px;
    line-height: 40px;
  }
}

.btn button {
  width: 100%;
  padding: 12px 20px;
}
</style>
<style lang="stylus" scoped>
@import "../../assets/styl/variables.styl"
.left-area
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 75px;
  background: #fff;
  cursor: pointer;
  font-size: 30px;
  color: #238ad5;
  display: flex;
  font-weight: 600;
  align-items: center;
  img
    border-style: none;
    height: 35px;
    margin-left: 60px;
    margin-right: 20px;
.login-col
  height 100%

.login-page
  display flex
  justify-content center
  align-items center
  position absolute
  width 100%
  height 100%
  background-image url('../../assets/images/login_bag.png');
  background-position left 75px;
  background-repeat no-repeat;
  background-size 100% 100%;
  .lang
    position absolute
    right 59px
    top 24px
  .svg-github
    position absolute
    right 29px
    top 25px
  .translate-left
  .translate-right
    will-change auto
    transform translateX(0px)
    transition transform .6s ease-in-out
  .switch-left
    transform translateX(525px)
  .switch-right
    transform translateX(-375px)

.login-wrap

  position absolute
  right 150px
  top 150px
  overflow hidden
  width 400px
  height 360px
  background white
  border-radius 4px
  transform translateY(-10px)
  box-shadow 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04)
  .login-box
    width :100%
    height:100%
  .logo
    padding-top 26px
    text-align center

  .title
    font-weight bold
    color main-color
    padding-top 8px
    font-size 22px

    a
      cursor cell
    a:before
      content '['
      opacity 0
      margin-right 10px
      transform translateX(-10px)
      transition transform .2s, opacity .2s

    a:after
      content ']'
      opacity 0
      margin-left 10px
      transform translateX(10px)
      transition transform .2s, opacity .2s

    a:hover:before
    a:hover:after
      opacity 1
      transform translateX(0)

    .subtitle
      color sub-color

  .forgetwrap-title
    padding-top 30px
    padding-left 15px

  .forget-form
    padding 20px 30px 30px
    padding-bottom 0

  .login-form
    padding 30px
    padding-bottom 0

  .login-footer
    padding 0 30px
    .forgetpwd
      text-align right
      span
        cursor pointer
        font-size 14px
        font-weight 500
        color #606266

  .wallpaper
    // width 100%
    // height 100%
    // background url('../../assets/images/login_bag.png')
    // background-size cover
    // position relative
</style>
